/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const fieldForceQuestions = [
    {
        id: questionIds.IfYesHaveOngoingSymptomsOrMedicationBeenOngoingForMoreThan12Months,
        questionText: "If you have answered yes to any of the previous questions, are these ongoing symptoms, diagnosis or treatments (including medication) been ongoing for longer than 12 months?",
    },
    {
        id: questionIds.IfYesHaveOngoingSymptomsOrMedicationBeenOngoingForMoreThan12MonthsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.HasThereBeenAnyChangeToVisionOrOngoingMedicalConditionSinceLastQuestionnaire,
        questionText: "Has there been any change to your vision or the ongoing medical condition, symptoms or to your treatment (including medication) since your last questionnaire?",
    },
    {
        id: questionIds.HasThereBeenAnyChangeToVisionOrOngoingMedicalConditionSinceLastQuestionnaireFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.AreAnySymptomsOrMedicationNewWithinLast12MonthsFieldForce,
        questionText: "Are the symptoms, diagnosis or medication new within the last 12 months?",
    },
    {
        id: questionIds.AreAnySymptomsOrMedicationNewWithinLast12MonthsFieldForceFurtherDetails,
        questionText: "Please provide details",
    }
];
